<div class="container">
  <div class="header">
    <div fiTranslation="BUTTON_NEW_LEAD"></div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-content">
    @if (!existingContact) {
      <div class="contact-container">
        <fi-contact-form
          [isNewLeadForm]="true"
          [requestForm]="requestForm"
          [showPrivate]="true"
          [contactForm]="contactForm"
          [privacy]="privacy"
          (privacyDocumentUploaded)="onPrivacyDocumentUpload($event)"
          (onMarketingChanges)="onMarketingChanges($event)"
          (hideErrors)="showErrors =  $event">
        </fi-contact-form>
      </div>
    }
    <div class="lead-container" [formGroup]="requestForm">

      @if (existingContact) {
        @if (showErrors && leadCreationFailureRelationshipManagementError) {
          <fi-alert tone="critical">
            <span fiTranslation="LEAD_ERRORMSG_CREATE_RELATIONSHIP_MANAGEMENT"></span>
          </fi-alert>
        }
      }

      <div class="section-text" fiTranslation="REQUEST_CREATE_TITLE"></div>

      <div class="input-row">
        <fi-input type="SELECT"
          [enableSearch]="true"
          labelKey="%ACTION_LEAD_TYPE_HEADLINE_REQUEST_TYPE%*"
          [replaceKeys]="true"
          [options]="leadTypes"
          [selectedOptionsOrValues]="requestForm.controls.LeadTypeId.value"
          [namePropertyPath]="'Description'"
          [valuePropertyPath]="'Id'"
          (onChange)="setLeadTypeId(+$event)"
          [hasError]="isInvalidForm('requestForm','LeadTypeId')"
        ></fi-input>

        @if (showLeadTypeAngebot) {
          <fi-input type="SELECT"
            [enableSearch]="true"
            labelKey="GENERAL_TEXT_CONSTRUCTION_TYPE"
            [options]="constructionTypes"
            [selectedOptionsOrValues]="requestForm.controls.ConstructionTypeId.value"
            [namePropertyPath]="'Description'"
            [valuePropertyPath]="'Id'"
            (onChange)="setConstructionTypeId(+$event)"
            [hasError]="isInvalidForm('requestForm','ConstructionTypeId')"
          ></fi-input>
        }

        @if (showLeadTypeBrochure) {
          <fi-input type="MULTI_SELECT"
            labelKey="{{broschureLabelText}}"
            [enableSearch]="true"
            [multiLineOptionText]="true"
            [placeholderKey]="'%REQUEST_DETAIL_EDIT_HEADER_ARTICLE_BROSCHURE_PLACEHOLDER%'"
            [replaceKeys]="true"
            [showSelectedOnTop]="true"
            [options]="brochures"
            [namePropertyPath]="'text'"
            [valuePropertyPath]="'value'"
            [imagePropertyPath]="'image'"
            (onValuesChange)="selectedBrochureKeys = $event"
          ></fi-input>
        }

        @if (showLeadTypeMuster) {
          <fi-input type="MULTI_SELECT"
            labelKey="{{musterLabelText}}"
            [enableSearch]="true"
            [placeholderKey]="'%REQUEST_DETAIL_EDIT_HEADER_ARTICLE_SAMPLE_PLACEHOLDER%'"
            [replaceKeys]="true"
            [showSelectedOnTop]="true"
            [options]="musters"
            [namePropertyPath]="'text'"
            [valuePropertyPath]="'value'"
            (onValuesChange)="selectedMusterKeys = $event"
          ></fi-input>
        }

        @if (showLeadTypeAusschreibungstexte) {
          <fi-input type="MULTI_SELECT"
            labelKey="{{ausschreibungstexteLabelText}}"
            [placeholderKey]="'%REQUEST_DETAIL_EDIT_HEADER_ARTICLE_TENDER_PLACEHOLDER%'"
            [enableSearch]="true"
            [replaceKeys]="true"
            [showSelectedOnTop]="true"
            [options]="ausschreibungstextes"
            [namePropertyPath]="'text'"
            [valuePropertyPath]="'value'"
            (onValuesChange)="selectedAusschreibungstexteKeys = $event"
          ></fi-input>
        }

        @if (showLeadTypeCadDaten) {
          <fi-input type="MULTI_SELECT"
            labelKey="{{cadDateLabelText}}"
            [placeholderKey]="'%REQUEST_DETAIL_EDIT_HEADER_ARTICLE_CAD_PLACEHOLDER%'"
            [enableSearch]="true"
            [replaceKeys]="true"
            [showSelectedOnTop]="true"
            [options]="cadDatens"
            [namePropertyPath]="'text'"
            [valuePropertyPath]="'value'"
            (onValuesChange)="selectedCadDatenKeys = $event"
          ></fi-input>
        }
      </div>

      <div class="input-row LeadSourceId" #inputs>
        <fi-input type="SELECT"
          [enableSearch]="true"
          labelKey="%REQUEST_CREATE_HEADLINE_LEADSOURCE%*"
          [replaceKeys]="true"
          [options]="leadSources"
          [selectedOptionsOrValues]="requestForm.controls.LeadSourceId.value"
          [namePropertyPath]="'Description'"
          [valuePropertyPath]="'Id'"
          (onChange)="requestForm.controls.LeadSourceId.setValue(+$event)"
          [hasError]="isInvalidForm('requestForm','LeadSourceId')"
        ></fi-input>

        @if (showLeadTypeAngebot) {
          <div [formGroup]="extPropertiesForm">
            <fi-input
              additionalContentPosition="START"
              labelKey="GENERAL_TEXT_PLANER_KOMPOSITION"
              [form]="extPropertiesForm"
              controlName="PLANER_CODE"
              [maxLength]="5"
              [hasError]="isInvalidForm('extPropertiesForm','PLANER_CODE')"
              >
              <span class="code-text">N°</span>
            </fi-input>
          </div>
        }
      </div>


      <div class="input-row">
        <fi-input
          [options]="shownPossibleTags"
          namePropertyPath="*"
          valuePropertyPath="*"
          [maxLength]="40"
          [enableSearch]="true"
          [clearOnEnterOrSelect]="true"
          type="SELECT"
          placeholderKey="REQUEST_DETAIL_HEADER_ADD_TAG_PLACEHOLDER"
          labelKey="REQUEST_DETAIL_OVERLAY_TAGS_LABEL"
          (onChange)="tags.push($event); updateTags();"
          (onEnterPressed)="tags.push($event); updateTags();"
          >
        </fi-input>
      </div>

      @if (tags.length) {
        <div class="tags">
          @for (tag of tags; track tag; let i = $index) {
            <div class="tag">
              <span>{{ tag }}</span>
              <mat-icon (click)="tags.splice(i, 1); updateTags();">close</mat-icon>
            </div>
          }
        </div>
      }

      <div>
        <div #inputs class="label LeadText" fiTranslation="ACTION_GENERAL_HEADLINE_REQUEST_NOTE"></div>
        <fi-editor (textChanged)="requestForm.controls.LeadText.setValue($event)"
          (isLongDescription)="isLongDescription = $event"
          (filesUploaded)="onAttachmentsUpdate($event); "
          [hideSendButton]="true"
          [isInvalid]="isInvalidForm('requestForm','LeadText')"
          placeholderTranslation="">
        </fi-editor>
      </div>

      @if (selectedLeadTypeId !== leadTypeRelationshipManagement) {
        <fi-address-editor class="address-editor" [form]="addressForm"
          [contactForm]="contactForm"
          (onSameAsContactAddress)="sameAsContactAddress = $event">
        </fi-address-editor>
      }

      @if (showSharedLeadCheckbox) {
        <fi-shared-lead-checkbox class="shared-lead-checkbox"
          [disabled]="this.selectedLeadTypeId === this.leadTypeRelationshipManagement"
          [checked]="isShared"
          (checkedChange)="isShared = $event; onChangeSharedStatus()"
        ></fi-shared-lead-checkbox>
      }
    </div>
  </div>

  <div class="footer">
    <button type="button" (click)="submitData()" [disabled]="!allRequiredFieldsFilled">
      <img src="/assets/icons/new/plus-light.svg" alt="add">
      <span fiTranslation="BUTTON_NEW_LEAD"></span>
    </button>
  </div>
</div>
